import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/dynamicform";

const dynamicForm = {
  selectFormPage(param) {
    return http.spin.get(`${BASE}/selectFormPage`, param);
  },
  copyFormDetail(param) {
    return http.get(`${BASE}/copyFormDetail`, param);
  },
  selectFormDetail(param) {
    return http.get(`${BASE}/selectFormDetail`, param);
  },
  citations(param) {
    return http.get(`${BASE}/citations`, param);
  },
  /** 新建 / 更新动态表单（JSON body） */
  saveOrUpdateForm(param) {
    return http.spin.payload(`${BASE}/saveOrUpdateForm`, param);
  },
  /**
   * 动态表单已有数据的社区列表（对比分析社区下拉）
   * 旧 /old/api/pc/dynamicform/selectDynamicHaveOrg → oldpeople 网关
   */
  selectDynamicHaveOrg(param) {
    return http.get("/gateway/apps/oldpeople/api/pc/dynamicform/selectDynamicHaveOrg", param);
  },
};

export default dynamicForm;
